<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h1 class="mt-3">Detail užívateľa</h1>
      </div>
      <hr>
      <form-tag @userEditEvent="submitHandler" name="userForm" event="userEditEvent">
        <div class="form-group mb-3">
           <label for="first-name">Meno</label>
           <input
            v-model="user.firstName"
            type="text"
            required
            label="Meno"
            class="form-control"
            id="first-name"
            >

           <div class="invalid-feedback">
             Meno nesmie byť prázdne.
           </div>
        </div>
        <div class="form-group mb-3">
          <label for="last-name">Priezvisko</label>
          <input
              v-model="user.lastName"
              type="text"
              required
              label="Priezvisko"
              class="form-control"
              id="last-name"
              >
        
          <div class="invalid-feedback">
            Priezvisko nesmie byť prázdne.
          </div>
        </div>
        <div class="form-group mb-3">
          <label for="company">Spoločnosť</label>
          <input
            v-model="user.company"
            type="text"
            class="form-control"
            label="Spoločnosť"
            
           id="company">
        </div>

        <div class="form-group mb-3">
           <label for="email">E-mail</label>
           <input
            v-model="user.email"
            type="email"
            required
            class="form-control"
             
            id="email"
            >
          <div class="invalid-feedback">
            E-mail musí byť správny.
          </div>
        </div> 
        <div class="form-group mb-3">
          <label for="phone">Mobil</label>
          <input type="text" class="form-control" 
                 id="phone" required v-model="user.phone" :class="{'is-invalid': !isPhoneValid && isSubmitted}">
          <div class="invalid-feedback">
            Mobil musí začínať s '+421'.
          </div>
        </div>

        <div class="form-group mb-3">
          <label for="passwd">Heslo</label>
          <input
            v-model="user.passwd"
            type="text"
            :required="user.id === 0"
            label="Heslo"
            class="form-control"
            id="passwd"
            >
          <div class="invalid-feedback" >
            Heslo nesmie byť prázdne.
          </div>
        </div>
        <div class="form-group mb-3">
            <label v-if="user.id===0" for="repasswd">Heslo znovu</label>
            <input
                v-if="user.id===0"
                v-model="user.repasswd"
                type="text"
                required
                label="Heslo znovu"
                class="form-control"
                id="repasswd"
                >
            
            <div class="invalid-feedback" >
              Heslo znovu nesmie byť prázdne.
            </div>
        </div>

        <div class="field flex align-items-center justify-content-between mb-3" style="">
          <div class="w-5 grid">
              <label for="rola" class="col-12 p-0 pl-2 mt-1 md:col-2 md:mb-0 md:p-2">Rola</label>
              <div class="col-12 p-0 pl-2 md:col-10 md:p-2 ">
                <PrimevueSelect
                    id="rola"
                    v-model="selectedRole"
                    :options="roles"
                    optionLabel="name"
                    placeholder="Vyber rolu"
                    class="w-full"
                    @change="handleAdminChange"
                >
                  <template #value="slotProps">
                    <div v-if="slotProps.value.id != 0" class="">
                        <div>{{ slotProps.value.name }}</div>
                    </div>
                    <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                  </template>
                  <template #option="slotProps">
                      <div class="">
                        <div>{{ slotProps.option.name }}</div>
                      </div>
                  </template>
                </PrimevueSelect>  
                
              </div>
          </div>
          
          <div class="w-5 grid">
           
              <label  v-if="selectedRole.id === 2" for="color" class="col-12 p-0 pl-2 mt-1 md:col-3 md:mb-0 md:p-2">Farba</label>
              <div  v-if="selectedRole.id === 2" class="col-2 p-0 pl-2 md:col-2 md:p-2">
                <ColorPicker 
                  id="color" 
                  v-model="user.color" 
                  :format="'hex'" 
                  
                />
              </div>
           
        </div>
        </div>

        <div class="mt-2 float-start">
          <input type="submit" value="Uložiť" class="btn btn-primary me-2">
          <router-link to="/admin/users" class="btn btn-outline-secondary">Zrušiť</router-link>
        </div>
      </form-tag>

    </div>
  </div>
</template>

<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import FormTag from "@/components/forms/FormTag.vue";
//import TextInput from "@/components/forms/TextInput.vue";
import notie from "notie/dist/notie";
import router from "@/router";
import PrimevueSelect from "primevue/dropdown";
import ColorPicker from 'primevue/colorpicker';
//import CheckInput from "@/components/forms/CheckInput.vue";

export default {
  name: "UserEdit",
  components: {
    //CheckInput,
    PrimevueSelect,
    ColorPicker,
    'form-tag': FormTag,
    //'text-input': TextInput,
  },
  methods: {
    submitHandler() {
      if(!this.validateForm()){
        return
      }

      const userId = parseInt(String(this.$route.params.userId), 10)
      console.log('userId:', userId)

      const payload = {
        id: this.user.id,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        company: this.user.company,
        email:this.user.email,
        phone:this.user.phone,
        admin:this.user.admin,
        password:this.user.passwd,
        repassword:this.user.repasswd,
        active:true,
        color: this.selectedRole.id == 2 ? this.user?.color || "#ff0000" : "",
        role: this.selectedRole
      }

      let method = "POST"

      let url = "/v1/user/"

      if (userId > 0){
        method = "PUT"
        url = "/v1/user/" + userId
      }

      fetch(store.Api_url + url, Security.requestOptions(method, payload))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //console.log("error:", responseData.data.message);
              this.$emit('error', responseData.data.message);
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Užívateľ uložený"
              })
              this.user = responseData.data
              router.push("/admin/users");
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri uložení užívateľa" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení užívateľa" + error
            })
          })


    },
    
    validateForm() {
      this.isSubmitted = true; // Mark the form as submitted to show validation feedback
      this.isPhoneValid = this.user.phone.startsWith('+421');
      console.log('isPhoneValid:', this.isPhoneValid)
      return (
        this.isPhoneValid
      );
    },
    
    handleAdminChange() {
      if(this.selectedRole.id == 1){
        if(confirm("Povoľujete tomuto užívateľovi plné práva nad systémom?")){
          //this.user.admin = event.target.checked;
        }else {
          this.selectedRole.id = 3
          this.selectedRole.name = "skladník"
        }
      }
      //else{
      //  this.selectedRole.id = 3
      //  this.selectedRole.name = "skladník"
      //}

    }
  },

  data() {
    return {
      store,
      isPhoneValid: true,
      //isFirstNameValid : true,
      //isLastNameValid : true,
      //isEmailValid : true,
      //isPasswordValid : true,
      //isRePasswordValid : true,
      isSubmitted: false,
      //checkedAdmin :"",
      selectedRole: {id:0,name:""},
      roles: [],
      user: {
        id: 0,
        firstName: "",
        lastName: "",
        company: "",
        email: "",
        phone: "",
        passwd: "",
        repasswd: "",
        admin: false,
        color: "#ff0000",
        role: {id: 0,name:""},
      }
    }
  },
  watch: {
    'user.color'(newColor) {
      if (newColor && !newColor.startsWith('#')) {
        this.user.color = `#${newColor}`;
      }
    },
  },
  beforeMount() {
    console.log("calling user")
    Security.requireToken();

    if(store.user.role.id != 1 ){
      router.push("/")
      notie.alert({
        type: 'error',
        text: "Na túto akciu nemáte oprávnenia"
      })
    }

    fetch(store.Api_url + "/v1/user-role", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (!responseData) {
                notie.alert({
                      type: 'error',
                      text: "Zoznam rolí sa nepodarilo načítať: " + responseData.data.message,
                      position: "top"
                    })           
            } else {
              console.log(responseData);
              this.roles = responseData
             // const categ = {id:0, name:""}
             // this.categories.push(categ)

            }
          })
          .catch((error) => {
            notie.alert({
                      type: 'error',
                      text: "Zoznam rolí sa nepodarilo načítať: " + error,
                      position: "top"
            })           
    });

    if (parseInt(String(this.$route.params.userId), 10) > 0) {
      // editing an existing user
      const userId = String(this.$route.params.userId)

      fetch(store.Api_url + "/v1/user/" + userId, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              console.log("error:", responseData.data);
              this.$emit('error', responseData.data);
            } else {
              console.log(responseData);
              this.user = responseData.data
              // do not load user passwd
              this.user.passwd = ''
              this.user.repasswd = ''
              this.selectedRole = this.user.role

              //if(this.user.admin === true){
              //  this.checkedAdmin = "checked"
             // }
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri načítaní užívateľa" + error);
          })
    }


  }
}
</script>

<style scoped>
.form-control.is-invalid, .was-validated .form-control:invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + .75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(.375em + .1875rem) center;
  background-size: calc(.75em + .375rem) calc(.75em + .375rem);
}
</style>
